import { useEffect } from 'react';

import { useJobProspectsStatsActions } from './JobProspectsStatsContext';
import { getBiopharmaGroupsStats } from './restApi';

const BiopharmaGroupsStatsLoader = () => {
  const { initializeState, onResponse, onError } = useJobProspectsStatsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getBiopharmaGroupsStats({ onResponse, onError });
  }, []);

  return null;
};

export default BiopharmaGroupsStatsLoader;
